import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams, IOrderApiListResponse } from '@/types';

export const orderList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IOrderApiListResponse>> => {
    return axios.get('/api/order/list', { ...config, params });
};
